export default __webpack_public_path__ + "static/media/lastframe-md-2x.cb3ae314.jpg";